import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type TogglePartnerUserPrimaryInput = {
  partnerId: string;
  partnerUserId: string;
  primary: boolean;
};

// PATCH /api/partners/:id/users/:userId/primary
//
// Promotes (or demotes) a partner_user to primary. When promoting, the
// worker clears is_primary on every other partner_user for the same
// partner before setting the new one — partners always have at most one
// primary contact.
export function useTogglePartnerUserPrimary() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, TogglePartnerUserPrimaryInput>({
    mutationFn: ({ partnerId, partnerUserId, primary }) =>
      apiFetch<{ ok: true }>(`/partners/${partnerId}/users/${partnerUserId}/primary`, {
        method: "PATCH",
        body: JSON.stringify({ primary }),
      }),
    onSuccess: (_data, { partnerId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.users(partnerId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.detail(partnerId) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to update primary contact");
    },
  });
}
